import _Register from "./Register";
import _Checkout from "./Checkout";
import _Confirmation from "./Confirmation";

export const Register = _Register;
export const Checkout = _Checkout;
export const Confirmation = _Confirmation;
